import api from '../services/api';
import getHeaders from '../utils/returnHeaders';

// US-19: subcategorias ativas de uma categoria (dropdown dinamico no buscador).
const getExperienceSubcategories = async (categoryId) => {
  const header = getHeaders();
  return api.get(`/experience/subcategories?categoryId=${categoryId}`, header);
};

export { getExperienceSubcategories };
